import { SaveData } from "../models/SaveData";

declare const config: { API_URL: string };

export const API_URL = (config && config.API_URL) || "http://localhost:8085/tt-rest";

export const LOGIN_USER_URL = "/EAktywni/login";
export const REMIND_PASSWORD_USER_URL = (facilityIds: string) =>
  `/EAktywni/user/data/reset/password?objectIds=${facilityIds}`;
export const CREATE_NEW_USER_URL = (facilityIds: string) => `/EAktywni/create/webUser?objectIds=${facilityIds}`;
export const GET_USER_DATA_URL = (facilityIds: string) => `/EAktywni/user/data?objectIds=${facilityIds}`;
export const GET_USER_SELECTS_URL = (facilityIds: string) => `/EAktywni/exercises/future?facilityIds=${facilityIds}`;
export const GET_USER_PASSES_URL = (facilityIds: string) => `/EAktywni/user/passes?facilityIds=${facilityIds}`;
export const USER_CHANGE_PASS_URL = (facilityIds: string) => `/EAktywni/user/data/password?objectIds=${facilityIds}`;
export const PARTNER_B2B_CHANGE_PASS_URL = (facilityIds: string) =>
  `/EAktywni/admin/oper/password?objectIds=${facilityIds}`;
export const USER_EDIT_DATA_URL = (facilityIds: string) => `/EAktywni/user/data/edit?objectIds=${facilityIds}`;
export const GET_ZONE_SCHEME_URL = (facilityIds: string, exerciseIds: string) =>
  `/EAktywni/exercises/zoneScheme?facilityIds=${facilityIds}&exerciseIds=${exerciseIds}`;
export const GET_TICKETS_MOVIE_URL = (facilityIds: string, exerciseIds: string) =>
  `/EAktywni/exercises/zoneScheme/tickets?facilityIds=${facilityIds}&exerciseIds=${exerciseIds}`;
export const FAKE_LOGIN_USE_URL = "/EAktywni/session/fake";
// Dodawanie biletu do koszyka
export const ADD_TO_BASKET_URL = "/EAktywni/addTicket";
// Dodawanie wielu biletów do koszyka (batch) - przyjmuje { tickets: BasketItem[], facilityIds: string }
export const ADD_TICKET_LIST_URL = "/EAktywni/addTicketList";
export const ASSIGN_ASSORT_TO_BASKET_URL = "/EAktywni/assignAssort";
export const CLEAR_BASKET_URL = (facilityIds: string) => `/EAktywni/clearbasket?objectIds=${facilityIds}`;
export const GET_BASKET_URL = `/EAktywni/basket`;
export const REMOVE_ITEM_BASKET_URL = `/EAktywni/removeTicket`;
export const ACCEPT_TRANSACTION_URL = (data: SaveData) =>
  `/EAktywni/saveReservation?name=${data.name}&lastName=${data.lastName}&email=${data.email}&phone=${data.phone}&companyName=${data.companyName}&NIP=${data.NIP}&street=${data.street}&city=${data.city}&houseNumber=${data.houseNumber}&flatNumber=${data.flatNumber}&zipCode=${data.zipCode}&createInvoice=${data.createInvoice}&createUser=${data.createUser}`;
export const SAVE_RESERVATION_V2 = "/EAktywni/saveReservation/V2";
export const GET_SHOWS = (facilityIds: string, date?: string) => {
  if (date) {
    return `/EAktywni/shows?facilityIds=${facilityIds}&date=${date}`;
  }
  return `/EAktywni/shows?facilityIds=${facilityIds}`;
};

export const BLOCK_SEAT_URL = "/EAktywni/blockSeat";
export const UNBLOCK_SEAT_URL = "/EAktywni/unblockSeat";
export const ASSORT_GROUP_BY_FACILITY_URL = (facilityIds: string) =>
  `/EAktywni/sort/assortGroups?objectIds=${facilityIds}`;
export const GET_FOOD_LIST_URL = (facilityIds: string, assortGroupIds: string) =>
  `/EAktywni/facility/goods?objectIds=${facilityIds}&assortGroupIds=${assortGroupIds}`;
// REQUEST DO NOWEJ konfiguracje sprzedaży
export const GET_CONF_FACILITY = (facilityIds: string) =>
  `/EAktywni/facility/configuration/V2/byIds?objectIds=${facilityIds}`;
// REQUEST DO STAREJ KONFIGURAACJI
export const GET_OLD_CONF_FACILITY = (facilityIds: string) =>
  `/EAktywni/facility/configuration/byIds?objectIds=${facilityIds}`;
export const GET_STEP_SALE_CONFIG = (facilityIds: string) =>
  `/EAktywni/admin/stepSaleConfig?facilityIds=${facilityIds}`;

// Court Grid Schedule
export const GET_COURT_GRID_SCHEDULE = (
  facilityIds: string,
  date: string,
  courtNames: string,
  userIds?: string
) => {
  let url = `/EAktywni/attractions/court-grid-schedule?facilityIds=${facilityIds}&date=${date}&courtNames=${courtNames}`;
  if (userIds) {
    url += `&userIds=${userIds}`;
  }
  return url;
};

// Weekly Grid Schedule V2
export const GET_COURT_GRID_SCHEDULE_V2 = (
  facilityIds: string,
  dateFrom: string,
  dateTo: string,
  courtName: string,
  userIds?: string
) => {
  let url = `/EAktywni/attractions/court-grid-schedule-v2?facilityIds=${facilityIds}&dateFrom=${dateFrom}&dateTo=${dateTo}&courtName=${courtName}`;
  if (userIds) {
    url += `&userIds=${userIds}`;
  }
  return url;
};

// Metoda do pobierania kolorów  sortowanie
export const GET_COLORS = (facilityIds: string, colorIds?: string) =>
  `/EAktywni/sort/colors?objectIds=${facilityIds}${colorIds ? `&colorIds=${colorIds}` : ""}`;
//Metoda do pobierania Grup asortymentowych
export const GET_ASSORTGROUP = (facilityIds: string, assortGroupIds?: string) =>
  `/EAktywni/sort/assortGroups?objectIds=${facilityIds}${assortGroupIds ? `&assortGroupIds=${assortGroupIds}` : ""}`;
// Metoda do pobierania kształtów
export const GET_SHAPEGROUP = (facilityIds: string, shapeIds?: string) =>
  `/EAktywni/sort/shapes?objectIds=${facilityIds}${shapeIds ? `&shapeIds=${shapeIds}` : ""}`;
export const GET_BOOKINGGROUPS = (facilityIds: string) => `/EAktywni/sort/bookingGroups?objectIds=${facilityIds}`;

//Metoda do pobierania asrotymentów na podstawie grupy asortymentowej
export const GET_TICKET_BY_ASSORTGROUP = (facilityIds: string, colorId: string) =>
  `/EAktywni/facility/tickets?objectIds=${facilityIds}&assortGroupIds=${colorId}`;
//Metoda do pobierania asrotymentów na podstawie kolorów
export const GET_TICKET_BY_COLORS = (facilityIds: string, colorId: string) =>
  `/EAktywni/facility/tickets?objectIds=${facilityIds}&colorIds=${colorId}`;
//Metoda do pobierania asrotymentów na podstawie kształtów
export const GET_TICKET_BY_SHAPE = (facilityIds: string, colorId: string) =>
  `/EAktywni/facility/tickets?objectIds=${facilityIds}&shapeIds=${colorId}`;
//Metoda do pobierania asrotymentów na podstawie kolorów
export const GET_PASS_BY_COLORS = (facilityIds: string, colorId: string) =>
  `/EAktywni/facility/passes?objectIds=${facilityIds}&colorIds=${colorId}`;
export const GET_TICKET_BY_PARAMS = (
  facilityIds: string,
  shapeIds?: string,
  colorIds?: string,
  assortGroupIds?: string,
  assortIds?: string
) =>
  `/EAktywni/facility/tickets?objectIds=${facilityIds}${shapeIds ? `&shapeIds=${shapeIds}` : ""}${
    colorIds ? `&colorIds=${colorIds}` : ""
  }${assortGroupIds ? `&assortGroupIds=${assortGroupIds}` : ""}${assortIds ? `&assortIds=${assortIds}` : ""}`;

// Metoda do pobierania evenetów
export const GET_EVENTS = (
  facilityIds: string,
  exerciseName?: string,
  exerciseIds?: string,
  exerciseGroupIds?: string
) =>
  `/EAktywni/exercises/special?objectIds=${facilityIds}${exerciseName ? `&exerciseName=${exerciseName}` : ""}${
    exerciseIds ? `&exerciseIds=${exerciseIds}` : ""
  }${exerciseGroupIds ? `&exerciseGroupIds=${exerciseGroupIds}` : ""}`;
// Metoda pobierająca bilety do danego eventu
export const GET_TICKETS_EVENT = (facilityIds: string, exerciseGroupIds: string) =>
  `/EAktywni/exercises/tickets?objectIds=${facilityIds}&exerciseGroupIds=${exerciseGroupIds}`;
//Metoda pobierająca dostępne imprezy dla wybranego dnia
export const GET_EXERCISE_BY_DAY = (facilityIds: string, date: string) =>
  `/EAktywni/exercises/datesAndFacility?objectIds=${facilityIds}&date=${date}`;
// Metoda pobierająca bilety po wyborze godziny i zajęcia
export const GET_TICKET_BY_EXERCISE = (facilityIds: string, exerciseGroupIds: string) =>
  `/EAktywni/exercises/tickets?objectIds=${facilityIds}&exerciseGroupIds=${exerciseGroupIds}`;

// Request uniwersalny do pobierania exercise
export const GET_AVAILABLE_EXERCISE_UNIVERSAL = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string,
  name: string
) =>
  `/EAktywni/attractions/universal?facilityIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}&name=${name}&group=false`;

// Metoda pobierająca karnety
export const GET_PASSES = (
  facilityIds: string,
  colorIds?: string,
  shapeIds?: string,
  assortGroupIds?: string,
  assortIds?: string
) => {
  let url = `/EAktywni/facility/passes?objectIds=${facilityIds}`;
  if (colorIds) url += `&colorIds=${colorIds}`;
  if (shapeIds) url += `&shapeIds=${shapeIds}`;
  if (assortGroupIds) url += `&assortGroupIds=${assortGroupIds}`;
  if (assortIds) url += `&assortIds=${assortIds}`;
  return url;
};
// Pobieranie zajęć dostępnych w sprzedaży (Wszystkich)
export const GET_AVAILABLE_EXERCISE = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string,
  name?: string
) =>
  `/EAktywni/attractions/byDates?facilityIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}${
    name ? `&name=${encodeURIComponent(name)}` : ""
  }`;
// Pobieranie danych dot. Kart Klubowych
export const GET_CLUB_CART_DETAILS = (facilityIds: string, assortIds: string) =>
  `EAktywni/assorts/krakow/clubCardCheck?objectIds=${facilityIds}&assortIds=${assortIds}`;

// Pobieranie dostępnych dni na kalendarz (bez filtra name/passIds) – np. do wyróżnienia dni bez sprzedaży
export const GET_ATTRACTIONS_CALENDAR = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string
) =>
  `/EAktywni/attractions/calendar?facilityIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}`;
// Pobieranie dostępnych dni na kalendarz. Na podstawie exercise.name
export const GET_DAYS_AVAILABLE_BYNAME = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string,
  name: string
) =>
  `/EAktywni/attractions/calendar?facilityIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}&name=${name}`;
// Pobieranie dostępnych dni na kalendarz. Na podstawie exercise.group id
export const GET_DAYS_AVAILABLE_PASSIDS = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string,
  passIds: string
) =>
  `/EAktywni/attractions/calendar?facilityIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}&passIds=${passIds}`;
// Pobieranie zajęć na podstawie assortIDs
export const GET_EXERCISE_BY_PASSID = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string,
  passIds: string
) =>
  `/EAktywni/exercises/datesAndFacility/pass?dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}&passIds=${passIds}&facilityIds=${facilityIds}`;
// Pobór zajęc na harmonogramie
export const GET_SCHEDULE_EXERCISES = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string,
  exerciseGroupIds: string
) =>
  `/EAktywni/exercises/fitness/datesAndFacility?objectIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}&exerciseGroupIds=${exerciseGroupIds}`;
// Pobór zajęc na harmonogramie V2
export const GET_SCHEDULE_EXERCISES_V2 = (
  facilityIds: string,
  formattedDateFrom: string,
  formattedDateTo: string,
  exerciseGroupIds: string,
  zonesIds: string,
  humanIds: string,
  userIds?: number
) => {
  if (userIds) {
    return `/EAktywni/exercises/fitness/datesAndFacility/V2?objectIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}&exerciseGroupIds=${exerciseGroupIds}&zoneIds=${zonesIds}&humanIds=${humanIds}&userIds=0,${userIds}`;
  } else {
    return `/EAktywni/exercises/fitness/datesAndFacility/V2?objectIds=${facilityIds}&dateFrom=${formattedDateFrom}&dateTo=${formattedDateTo}&exerciseGroupIds=${exerciseGroupIds}&zoneIds=${zonesIds}&humanIds=${humanIds}`;
  }
};
// Pobieranie detatils o exercises
export const GET_SCHEDULE_DETAILS = (facilityIds: string, exerciseIds: string, userIds: string) =>
  `/EAktywni/exercises/fitness/details?objectIds=${facilityIds}&exerciseIds=${exerciseIds}&userIds=${userIds}`;
export const GET_SCHEDULE_DETAILS_NOLOGIN = (facilityIds: string, exerciseIds: string) =>
  `/EAktywni/exercises/fitness/details?objectIds=${facilityIds}&exerciseIds=${exerciseIds}`;
// Zapisywanie się karnetem na zajęcia
export const JOIN_TO_EXERCISE = (facilityIds: string, passId: string) =>
  `/EAktywni/exercises/fitness/entry?objectIds=${facilityIds}&passIds=${passId}`;

// Pobieranie grup zajęciowych
export const GET_EXERCISE_GROUPS = (facilityIds: string) => `/EAktywni/exerciseGroups?objectIds=${facilityIds}`;
// Pobieranie grup zajęciowych z filtrem na daty
export const GET_EXERCISE_GROUPS_DATES = (facilityIds: string, dateFrom: string, dateTo: string, kind: string) =>
  `/EAktywni/exerciseGroups/dates?objectIds=${facilityIds}&dateFrom=${dateFrom}&dateTo=${dateTo}&kind=${kind}`;
export const GET_ZONES_BY_DATES = (facilityIds: string, dateFrom: string, dateTo: string, kind: string) =>
  `/EAktywni/admin/zones/facility/dates?objectIds=${facilityIds}&dateFrom=${dateFrom}&dateTo=${dateTo}&kind=${kind}`;
export const GET_HUMANS_BY_DATES = (facilityIds: string, dateFrom: string, dateTo: string, kind: string) =>
  `/EAktywni/admin/humans/facility/dates?objectIds=${facilityIds}&dateFrom=${dateFrom}&dateTo=${dateTo}&kind=${kind}`;
// PObieranie checkboxów
export const GET_CHECKBOX_CONFIRMATION = (facilityIds: string) => `/EAktywni/admin/statutes?facilityIds=${facilityIds}`;
// Rezygnowanie z zapisanego zajęcia
export const GET_EXERCISE_RESIGN = (exerciseIds: string, facilityIds: string) =>
  `/EAktywni/exercises/future/resign?exerciseIds=${exerciseIds}&facilityIds=${facilityIds}`;
// Pobieranie dokumentów konto klienta
export const GET_USER_DOCUMENT = (facilityIds: string) => `/EAktywni/user/documents?facilityIds=${facilityIds}`;
// Pobieranie definicji wpłat
export const GET_CARD_DEFINITIONS = (facilityIds: string) =>
  `/EAktywni/account/depositDefinitions?objectIds=${facilityIds}`;
// Płatność przy definicji wpłat
export const GET_PAYMENT_DEFINITIONS = `/EAktywni/saveAccountIncome`;
// Kody rabatowe
export const GET_CALCULATE_PROM = (promotionCode: string, facilityIds: string) =>
  `/EAktywni/basket/calculate/promotion?promotionCode=${promotionCode}&facilityIds=${facilityIds}`;
// Pobieranie kart podarunkowych
export const GET_GIFT_CARD = (facilityIds: string) =>
  `/EAktywni/account/depositDefinitions/assorts?facilityIds=${facilityIds}`;

//pobieranie konfiguracji urodzin
export const GET_BIRTHDAY_CONFIG = (facilityIds: string) => `/EAktywni/birthDays/config?facilityIds=${facilityIds}`;

//pobranie godzin dla daty (moduł urodziny)
export const GET_TIME_FROM_BIRTHDAY = (facilityIds: string, dateFrom: string, dateTo: string, assortIds: string) =>
  `/EAktywni/birthDays/calendar?facilityIds=${facilityIds}&dateFrom=${dateFrom}&dateTo=${dateTo}&assortIds=${assortIds}`;

//zapis rezerwacji urodzin
export const SAVE_BIRTHDAY = (facilityIds: string, name: string, lastName: string, email: string, phone: string) =>
  `/EAktywni/birthDays/save?facilityIds=${facilityIds}&name=${name}&lastName=${lastName}&email=${email}&phone=${phone}`;

// Pobieranie biletów jako PDF
export const GET_DOWNLOAD_TICKET_PDF = (params: { facilityIds: string; documentIds: string }) =>
  `/EAktywni/user/documents/PDF/tickets?documentIds=${params.documentIds}&facilityIds=${params.facilityIds}`;
// Pobieranie dokumentu
export const GET_DOWNLOAD_DOCUMENT = (params: { facilityIds: string; documentIds: string }) =>
  `/EAktywni/user/documents/PDF?documentIds=${params.documentIds}&facilityIds=${params.facilityIds}`;
// Pobieranie aktualności
export const GET_NEWS = (facilityIds: string) => `/EAktywni/news?objectIds=${facilityIds}`;
// pobieranei zajęć/godzin w wybranym dniu na podstawie zone
export const GET_EXERCISE_BY_DATE_AND_NAME = (facilityIds: string, date: string, name: string) =>
  `/EAktywni/exercises/datesAndFacility?objectIds=${facilityIds}&date=${date}&name=${name}`;
//Przerabianie koszyka na e-kartę
export const GET_BASKET_BY_ECARD = (facilityIds: string) =>
  `/EAktywni/basket/calculate/eCard?facilityIds=0,${facilityIds}`;
// Potwierdzenie płatności ekartą
export const SAVE_BY_ECARD = () => `/EAktywni/saveReservation?eCard=true`;
// Czyszczenie wszelakich promocji
export const RESET_PROMOTION = (promotionCode: string, facilityIds: string) =>
  `/EAktywni/basket/calculate/promotion?promotionCode=${promotionCode}&facilityIds=${facilityIds}&clear=true`;
// Usuwanie bieżącego terminu
export const CANCLE_CURRENT_EXERCISE = (exerciseIds: string, facilityIds: string) =>
  `/EAktywni/exercises/future/resign?exerciseIds=${exerciseIds}&facilityIds=${facilityIds}`;
// Aktywacja usera
export const ACTIVATION_USER = (token: string, facilityIds: string) =>
  `/EAktywni/activate/user?a=${token}&facilityIds=${facilityIds}`;
// REZYGNACJA Z NEWSLETTERA
export const RESIGN_FROM_NEWSLETTER = (facilityIds: string, email: string) =>
  `/EAktywni/user/cancelNewsletterAgreement?facilityIds=${facilityIds}&email=${email}`;
// pobieranie danych o zamowieniu
export const GET_CONFIRMATION = (params: { facilityIds: string; billKey: string }) =>
  `/EAktywni/confirmation?facilityIds=${params.facilityIds}&k=${params.billKey}`;
export const GET_CONFIRMATION_DOCUMENT = (params: { facilityIds: string; billKey: string }) =>
  `/EAktywni/confirmation/document?facilityIds=${params.facilityIds}&k=${params.billKey}`;
export const GET_CONFIRMATION_TICKETS = (params: { facilityIds: string; billKey: string }) =>
  `/EAktywni/confirmation/tickets?facilityIds=${params.facilityIds}&k=${params.billKey}`;
export const CHANGE_NEWSLETTER_AGREEMENT = (facilityIds: string, hash: string) =>
  `/EAktywni/user/changeNewsletterAgreement/stage2?hash=${encodeURIComponent(hash)}&facilityIds=${facilityIds}`;
export const NEWSLETTER_AGREEMENT = (facilityIds: string, email: string) =>
  `  /EAktywni/user/changeNewsletterAgreement/byEmail?facilityIds=${facilityIds}&email=${email}`;

export const CHANGE_PASSWORD_BY_HASH = (facilityIds: string) =>
  `/EAktywni/user/data/password/V2?facilityIds=${facilityIds}`;
export const REMOVE_WEB_USER = (facilityIds: string) => `/EAktywni/remove/webUser?objectIds=${facilityIds}`;
export const GET_BASKET_QB = (facilityIds: string) => `/EAktywni/basket/QB?facilityIds=${facilityIds}`;
export const SAVE_BASKET_QB = (facilityIds: string) => `/EAktywni/basket/QB/applyDiscount?facilityIds=${facilityIds}`;

export const GET_LEGACY_EXERCISES = (
  facilityIds: string,
  isPass: boolean,
  dateFrom: string,
  dateTo: string,
  exerciseGroupIds?: string
) => {
  let query = `/EAktywni/legacy/exercises?objectIds=${facilityIds}&isPass=${isPass}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
  if (exerciseGroupIds) query += `&exerciseGroupIds=${exerciseGroupIds}`;
  return query;
};
export const GET_LEGACY_ASSORTS = (
  facilityIds: string,
  kind: string,
  exerciseGroupIds?: string,
  bookingGroupIds?: string,
  materialGroupIds?: string,
  colorIds?: string
) => {
  let query = `/EAktywni/legacy/assorts?objectIds=${facilityIds}&kind=${kind}`;

  // Sprawdzamy, czy opcjonalne parametry mają wartość, zanim je dodamy
  if (exerciseGroupIds) query += `&exerciseGroupIds=${exerciseGroupIds}`;
  if (bookingGroupIds) query += `&bookingGroupIds=${bookingGroupIds}`;
  if (materialGroupIds) query += `&materialGroupIds=${materialGroupIds}`;
  if (colorIds) query += `&colorIds=${colorIds}`;

  return query;
};

export const SAVE_BASKET_QUESTIONS = (objectIds: string) =>
  `/EAktywni/assorts/questionList/saveAnswers?objectIds=${objectIds}`;

export const B2B_REGISTER = (facilityIds: string) => `/EAktywni/b2b/register?objectIds=${facilityIds}`;
export const REGISTER_PARTICIPANTS_URL = (facilityIds: string) => `/EAktywni/register/users?objectIds=0,${facilityIds}`;

// Pobieranie dostępnych krajów
export const GET_COUNTRIES = (facilityIds: string) => `/EAktywni/countries?facilityIds=${facilityIds}`;

// zwracanie asortymentów na podstawie karty
export const GET_DETAILS_FROM_CARD = (facilityIds: string, code:string) => `/EAktywni/user/data/code?objectIds=${facilityIds}&code=${code}&userLanguage=PL`;

// Pobieranie wszystkich asortymentów (nowy endpoint dla facilityIds 1241 i 1243)
export const GET_ALL_ASSORTS = (
  facilityIds: string,
  colorIds?: string,
  shapeIds?: string,
  assortGroupIds?: string,
  assortIds?: string,
  userLanguage?: string
) => {
  let url = `/EAktywni/facility/all-assorts?objectIds=${facilityIds}`;
  if (colorIds) url += `&colorIds=${colorIds}`;
  if (shapeIds) url += `&shapeIds=${shapeIds}`;
  if (assortGroupIds) url += `&assortGroupIds=${assortGroupIds}`;
  if (assortIds) url += `&assortIds=${assortIds}`;
  if (userLanguage) url += `&userLanguage=${userLanguage}`;
  return url;
};

// Pobieranie limitów asortymentów dla grupy zajęciowej (koncerty)
export const GET_EXERCISE_ASSORT_LIMITS = (facilityIds: string, exerciseIds: string) =>
  `/EAktywni/exercise/assorts/limits?facilityIds=${facilityIds}&exerciseIds=${exerciseIds}`;

